export default "__VITE_ASSET__Dx3pmxXE__"